<template>
  <section class="inner-page">
    <Header :close-menu="onCloseMenu" />

    <slot />

    <main-nav-menu :is-menu-active="isMenuActive" @close-menu="onCloseMenu" />
  </section>
</template>

<script>
import MainNavMenu from "./MainNavMenu";
import Header from "./Header";

export default {
  name: "InnerPageWrapp",
  components: { MainNavMenu, Header },
  data() {
    return {
      isMenuActive: false
    };
  },
  methods: {
    onCloseMenu() {
      this.isMenuActive = !this.isMenuActive;
    }
  }
};
</script>
